import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CookieConsent } from "@/components/CookieConsent";
import HomePage from "@/pages/HomePage";
import SystemsPage from "@/pages/SystemsPage";
import FounderPage from "@/pages/FounderPage";
import BuyerPage from "@/pages/BuyerPage";
import BuyerAccessPage from "@/pages/BuyerAccessPage";
import InvestorAccessPage from "@/pages/InvestorAccessPage";
import OperatorsPage from "@/pages/OperatorsPage";
import MethodologyPage from "@/pages/MethodologyPage";
import EngagementPage from "@/pages/EngagementPage";
import LegalPage from "@/pages/LegalPage";
import AuthorityLibraryPage from "@/pages/AuthorityLibraryPage";
import ExpansionPage from "@/pages/ExpansionPage";
import CredibilityPage from "@/pages/CredibilityPage";
import GovernancePage from "@/pages/GovernancePage";
import CertificationPage from "@/pages/CertificationPage";
import OperatorApplicationPage from "@/pages/OperatorApplicationPage";
import ManifestoPage from "@/pages/ManifestoPage";
import BookPage from "@/pages/BookPage";
import CoursePage from "@/pages/CoursePage";
import LicensePage from "@/pages/LicensePage";
import GlossaryPage from "@/pages/GlossaryPage";
import PortalPage from "@/pages/PortalPage";
import AuthorityReviewPage from "@/pages/AuthorityReviewPage";
import InsightsPage from "@/pages/InsightsPage";
import InsightDetailPage from "@/pages/InsightDetailPage";
import CaseStudiesPage from "@/pages/CaseStudiesPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/systems" element={<SystemsPage />} />
              <Route path="/methodology" element={<MethodologyPage />} />
              <Route path="/engagement" element={<EngagementPage />} />
              <Route path="/library" element={<AuthorityLibraryPage />} />
              <Route path="/expansion" element={<ExpansionPage />} />
              <Route path="/credibility" element={<CredibilityPage />} />
              <Route path="/governance" element={<GovernancePage />} />
              <Route path="/certification" element={<CertificationPage />} />
              <Route path="/operator-application" element={<OperatorApplicationPage />} />
              <Route path="/manifesto" element={<ManifestoPage />} />
              <Route path="/book" element={<BookPage />} />
              <Route path="/course" element={<CoursePage />} />
              <Route path="/license" element={<LicensePage />} />
              <Route path="/glossary" element={<GlossaryPage />} />
              <Route path="/portal" element={<PortalPage />} />
              <Route path="/operators" element={<OperatorsPage />} />
              <Route path="/founder" element={<FounderPage />} />
              <Route path="/buyer" element={<BuyerPage />} />
              <Route path="/buyer-access" element={<BuyerAccessPage />} />
              <Route path="/investor-access" element={<InvestorAccessPage />} />
              <Route path="/legal" element={<LegalPage />} />
              <Route path="/authority-review" element={<AuthorityReviewPage />} />
              <Route path="/insights" element={<InsightsPage />} />
              <Route path="/insights/:slug" element={<InsightDetailPage />} />
              <Route path="/case-studies" element={<CaseStudiesPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
            <CookieConsent />
          </BrowserRouter>
          <Toaster position="bottom-right" />
        </div>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
